<arc-shared-login-widget-ultimate
  applicationId="{{ config.applicationId }}"
  featureId="{{ config.featureId }}"
  personaId="{{ config.personaId }}"
  [tenantId]="tenantId"
  [widgetMode]="'external'"
  [showMessage]="false"
>
</arc-shared-login-widget-ultimate>
